import {
  Component, Input, ViewEncapsulation, AfterContentChecked, AfterContentInit,
  AfterViewChecked, ElementRef
} from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { HttpHeaders, HttpResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { UtilityService, HttpClientService, AuthenticationService } from './../../../lib/ng2-sapmp/src/providers';
import { AccordionModel } from './../../../lib/ng2-sapmp/src/ui-components';
import { KEY_CONFIG } from './../../../lib/ng2-sapmp/src/config/key-config';
import { NotificationService } from './shared/notification.service';

declare var ENV_PORTAL: any;

@Component({
  selector: 'app-notifications',
  templateUrl: './notification.component.html',
  styleUrls: ['./notifications.component.scss'],
  providers: [NotificationService],
  encapsulation: ViewEncapsulation.None
})

export class NotificationAlertComponent implements AfterContentChecked, AfterContentInit, AfterViewChecked {

  public notificationAccordionData: Array<any>;
  public lazyLoadAlerts: any;
  public showSeeMore: boolean;
  public loading: boolean;
  public efotaAlertsCount: number = 0;
  public alertsList = [];
  private alerts: any;
  private scrollToNew: boolean;
  private updateView: boolean;
  private startOffset: number;
  private endOffset: number;
  private currentOffset: number;
  private focusElement: any;
  private addpAuthority: any;
  private addpAllow: boolean;
  private totalAlerts: any;
  public adminPortal: boolean = false;


  // Configure either of the properties  to control the visible alerts on page load
  @Input() visibleAlerts: number;
  @Input() visibleViewport: number;

  constructor(private util: UtilityService, private router: Router,
    private el: ElementRef, private httpService: HttpClientService,
    private authService: AuthenticationService, private notificationService: NotificationService) {
    const endIndex = this.visibleAlerts ? this.visibleAlerts * 2 : 6;  // EndIndex to include visible alerts and buffer
    this.loading = true;
    this.addpAllow = false;
    if (ENV_PORTAL === "dmpadmin" ) {
      this.adminPortal = true;
    }
    if (sessionStorage.getItem('user')) {
      this.addpAuthority = JSON.parse(sessionStorage.getItem('user')).user.addpAuthority;
      if (this.addpAuthority === 'READ_ONLY') {
        this.addpAllow = true;
      }
    }
    const userObj = authService.getUser();
    if (userObj) {
      let userName;
      if((userObj.firstName.length == 0 || userObj.firstName == 'NOT_FOUND') && (userObj.lastName.length == 0 || userObj.lastName == 'NOT_FOUND')) {
        userName = "Unknown";
      }
      else if((userObj.firstName.length > 0 && userObj.firstName != 'NOT_FOUND') && (userObj.lastName.length == 0 || userObj.lastName == 'NOT_FOUND')) {
        userName = userObj.firstName;
      }
      else if((userObj.firstName.length == 0 || userObj.firstName == 'NOT_FOUND') && (userObj.lastName.length > 0 && userObj.lastName != 'NOT_FOUND')) {
        userName = userObj.lastName;
      }
      else {
        userName = userObj.firstName + ' ' + userObj.lastName;
      }
      document.getElementsByClassName('first-name')[0].innerHTML = userName;
    }

    sessionStorage.setItem('hideNotifications', 'true');
    this.alerts = [];
    this.lazyLoadAlerts = [];
    if (!(this.visibleAlerts || this.visibleViewport)) {
      this.visibleViewport = 570;
    }

    this.notificationAccordionData = [];
    if ( this.addpAuthority !== 'NONE' && !this.adminPortal) {
      this.notificationService.getAlerts().subscribe(resObj => {
        this.loading = false;
        this.alerts = resObj.alerts;
        const totalAlerts = this.alerts.length;
        sessionStorage.setItem("alerts", JSON.stringify(this.alerts));
        let efotaAlerts = [];
        this.efotaAlertsCount = 0;
        for(let i=0 ; i<this.alerts.length; i++) {
          if(this.alerts[i].title == "New EFOTA Report Available") {
            this.efotaAlertsCount++;
            efotaAlerts.push(this.alerts[i]);
          }
        }
        sessionStorage.setItem("efotaAlerts", JSON.stringify(efotaAlerts));
        if(this.efotaAlertsCount) {
          sessionStorage.setItem("efotaAlertsCount", this.efotaAlertsCount.toString());
        }
        else {
          sessionStorage.setItem("efotaAlertsCount", "0");
        }
        this.notificationAccordionData.push(this.createAccordionModel(totalAlerts));
        if (totalAlerts) {
          this.updateCountBubble(totalAlerts);
          sessionStorage.setItem('newNotifications', totalAlerts.toString());
        }
  
        // The height of anything inside the container is added to startOffset
        const loginBoxHeight = document.getElementsByClassName('notification-box')[0].clientHeight;
        this.startOffset = this.visibleViewport ? loginBoxHeight : 0;
  
        this.lazyLoadAlerts = this.alerts.splice(0, endIndex);
      }, err => {
        this.notificationAccordionData.push(this.createAccordionModel(0));
        this.loading = false;
      });
    } else {
      this.loading = false;
    }
  }

  ngAfterContentInit() {
    const alertParent = document.getElementsByTagName('app-parent');
    // Close accordion when clicked outside
    document.addEventListener('click', (event) => {
      let sourceElement = <HTMLElement> event.srcElement;
      if (!alertParent[0].contains(sourceElement) && document.contains(sourceElement) && this.notificationAccordionData[0]) {
        this.notificationAccordionData[0].isActive = false;
      }
    });
  }

  ngAfterContentChecked() {
    if (this.alerts) {
      this.showSeeMore = this.alerts.seeMore;
    }
    const alertList = document.querySelectorAll('.notification-list li:not([hidden])');
    if (alertList && this.scrollToNew) {
      this.scrollToNew = false;
      // Scroll last loaded alert into view
      alertList[alertList.length - 1].scrollIntoView(false);
    }
  }

  ngAfterViewChecked() {
    if (this.alerts && this.updateView) {
      this.updateView = false;
      const currentOffset = this.currentOffset;
      this.updateAlertsView(currentOffset);
    }
  }

  removeAlert(accordion: AccordionModel, index: number, event: Event) {
    event.stopPropagation();
    event.preventDefault();
    const envConfig = this.util.getEnvConfig();
    sessionStorage.setItem('hideNotifications', 'false');
    let alertsCount = JSON.parse(document.getElementById('alert-widget').innerHTML);
        alertsCount = alertsCount-1;
        if(alertsCount){      
          document.getElementById('alert-widget').innerHTML = alertsCount;
        }
        else{
          document.getElementById('alert-widget').innerHTML = alertsCount;
          document.getElementById('alert-widget').setAttribute('style', 'display: none');
        }
    if(!this.adminPortal) {
    this.httpService.request(envConfig.notificationsUrl + '' + this.lazyLoadAlerts[index].id, 'delete',  '', this.notificationService.getHeaders())
      .pipe(
       map((res: HttpResponse<any>) => {
        if (sessionStorage.getItem('sapmp_jwtToken') != null) {
          // refreshes token for logged in scenario upon page load
          this.httpService.tokenRefresh(this.util.getEnvConfig().tokenRefresh);
        }
        this.alertsList = JSON.parse(sessionStorage.getItem("alerts"));
    if(this.alertsList[index].title == "New EFOTA Report Available") {
      this.efotaAlertsCount--;
      sessionStorage.setItem("efotaAlertsCount", JSON.stringify(this.efotaAlertsCount));
      delete this.alertsList[index];
      this.alertsList = this.alertsList.filter(item => {
        return item != null;
      });
      sessionStorage.setItem("alerts",JSON.stringify(this.alertsList));
    }
    else {
      delete this.alertsList[index];
      this.alertsList = this.alertsList.filter(item => {
        return item != null;
      });
      sessionStorage.setItem("alerts",JSON.stringify(this.alertsList));
    }
        return res.body;
      }))
      .subscribe(res => {
        console.log(res);
      }, err => {
        console.log(err);
      });
    }
    this.lazyLoadAlerts.splice(index, 1);
    // sessionStorage.setItem('hideNotifications', 'true');
    accordion.category = accordion.id + ' <div class="count-circle">' + (this.lazyLoadAlerts.length + this.alerts.length) + '</div>';
    const current = this.visibleViewport ? Math.ceil(this.currentOffset / this.visibleViewport) * this.visibleViewport :
      this.currentOffset;
    if (this.showSeeMore) {
      this.updateAlertsView(current);
      this.lazyLoadAlerts = this.lazyLoadAlerts.concat(this.alerts.splice(0, 1));
      this.updateView = true;
    }
    // To create gray title when count is 0
    if (this.lazyLoadAlerts.length < 1) {
      let alerttitle = <HTMLElement><any>document.getElementsByClassName('toggle-header')[0];
      alerttitle.classList.add('active');
    }
  }

  handleKeypress(accordion: AccordionModel, index: number, event) {
    if (event.keyCode === KEY_CONFIG.space || event.keyCode === KEY_CONFIG.enter) {
      this.removeAlert(accordion, index, event);
      if (this.lazyLoadAlerts[index]) {
        this.focusElement = document.getElementById('alert' + this.lazyLoadAlerts[index].id);
        this.focusElement.querySelectorAll('[tabindex="0"]')[0].focus();
      } else {
        this.el.nativeElement.querySelectorAll('.icon-accordion-minus')[0].focus();
      }
    }
  }

  navigate(accordion: AccordionModel, index: number, event) {
    if (!event.keyCode || event.keyCode === KEY_CONFIG.space || event.keyCode === KEY_CONFIG.enter) {
      event.stopPropagation();
      event.preventDefault();
      document.getElementById('userProfileInfo').classList.toggle('show');
      document.body.classList.toggle('d-open');
      const action = this.lazyLoadAlerts[index].actionLink[0].action;
      document.getElementById('icon-close-log-out').setAttribute('style', 'display: none');
      document.getElementById('icon-log-out').setAttribute('style', 'display: inline');
      this.removeAlert(accordion, index, event);
      if (action.indexOf('.') > -1) {
        window.open(action, '_new');
      } else {
        this.router.navigate([action]);
      }
    }
  }

  createAccordionModel(length: number) {
    const accordionModel = new AccordionModel();
    accordionModel.id = 'Alerts';
    accordionModel.isActive = true;
    accordionModel.category = 'Alerts' + ' <div class="count-circle">' + length + '</div>';
    accordionModel.ariaLabel = {
      'expand': 'Show alerts.',
      'collapse': 'Hide alerts.',
    };
    return accordionModel;
  }

  showAlert(loaded: true) {
    if (this.visibleViewport) {
      this.startOffset = this.startOffset + document.getElementsByClassName('toggle-header')[0].clientHeight;
    }
    this.currentOffset = this.startOffset;
    this.updateAlertsView();
    this.notificationAccordionData[0].isActive = false;
  }

  updateAlertsView(loadMore?) {
    this.endOffset = this.startOffset;
    this.focusElement = undefined;
    this.alerts.seeMore = false;
    this.lazyLoadAlerts.forEach((alert, index) => {
      if (this.visibleViewport && !alert.height) {
        alert.height = this.computeElHeight(alert.id);
      }
      this.getVisibleAlerts(alert, index, loadMore);
    });
  }

  getVisibleAlerts(alert, index, loadMore?) {
    const endOffset = alert.height || 1;
    const viewLimit = this.visibleViewport || this.visibleAlerts;
    this.endOffset = this.endOffset + endOffset;
    const containerLimit = loadMore > viewLimit ? loadMore : viewLimit;
    const container = document.getElementById('alert' + alert.id);
    if (this.endOffset > containerLimit) {
      container.parentElement.hidden = true;
      this.alerts.seeMore = true;
    } else {
      if (container.parentElement.hidden && !this.focusElement) {
        this.focusElement = container;
      }
      this.currentOffset = this.endOffset;
      container.parentElement.hidden = false;
    }
  }

  showMoreAlerts(event: Event) {
    this.scrollToNew = true;
    const current = this.currentOffset + (this.visibleViewport || this.visibleAlerts);
    const endIndex = this.visibleAlerts ? this.visibleAlerts : 3;
    this.updateAlertsView(current);
    this.lazyLoadAlerts = this.lazyLoadAlerts.concat(this.alerts.splice(0, endIndex));
    this.updateView = true;
    // Added for CATO
    this.focusElement.querySelectorAll('[tabindex="0"]')[0].focus();
  }

  // Will show the first two alerts and the whole process repeats
  showFewerAlerts(event: Event) {
    this.alerts = this.lazyLoadAlerts;

    const endIndex = this.visibleAlerts ? this.visibleAlerts * 2 : 2;
    this.lazyLoadAlerts = [];
    const loginBoxHeight = document.getElementsByClassName('notification-box')[0].clientHeight;
    this.startOffset = this.visibleViewport ? loginBoxHeight : 0;
    this.lazyLoadAlerts = this.alerts.splice(0, endIndex); // take all the alerts here.

    this.showMoreAlerts(event);
    this.showAlert(true);

    this.alerts.seeMore = true;
  }
  // calculating the height of each alert
  computeElHeight(alertId) {
    return document.getElementById('alert' + alertId).clientHeight;
  }

  accordionOpen(event: Event) {
    event.stopPropagation();
  }

  // Updating the count-bubble in the header
  updateCountBubble(totalAlerts) {
    const alertWidget = document.getElementById('alert-widget');
    document.getElementById('icon-log-out').setAttribute('style', 'margin-right: -10px');
    alertWidget.innerHTML = totalAlerts;
    alertWidget.setAttribute('style', 'display: inline');
    sessionStorage.setItem('hideNotifications', 'false');
  }

  handleKeydown(event) {
    event.preventDefault();
    event.stopPropagation();
    if (event.keyCode === KEY_CONFIG.space || event.keyCode === KEY_CONFIG.enter) {
      this.showMoreAlerts(event);
    } else if (event.keyCode === KEY_CONFIG.tabKey) {
      this.el.nativeElement.querySelectorAll('.icon-accordion-minus')[0].focus();
    }
  }
}
